import type { GlobalSearchResultItem } from 'models';
import type { ReactNode } from 'react';

import {
  CommunityItem,
  CurriculumItem,
  EventItem,
  FileItem,
  GivingItem,
  OrganizationItem,
  PostItem,
  UserItem,
} from '../search-items';
import type { SearchItemTypeKey } from '../search-result-routes';

export const searchResultHeaders: Record<SearchItemTypeKey, ReactNode> = {
  activities: 'Activities',
  communities: 'Communities',
  events: 'Events',
  files: 'Files',
  givings: 'Giving',
  organizations: 'Organizations',
  polls: 'Polls',
  posts: 'Conversations',
  programs: 'Programs',
  users: 'People',
};

type P = {
  itemActionProps?: Record<string, unknown>;
  itemProps: GlobalSearchResultItem;
  type: SearchItemTypeKey;
};

export const SearchResultItem = ({ itemActionProps, itemProps, type }: P) => {
  switch (type) {
    case 'activities':
    case 'polls':
    case 'posts':
      return <PostItem itemActionProps={itemActionProps} itemProps={itemProps} />;
    case 'communities':
      return <CommunityItem itemActionProps={itemActionProps} itemProps={itemProps} />;
    case 'events':
      return <EventItem itemActionProps={itemActionProps} itemProps={itemProps} />;
    case 'files':
      return <FileItem itemActionProps={itemActionProps} itemProps={itemProps} />;
    case 'givings':
      return <GivingItem itemActionProps={itemActionProps} itemProps={itemProps} />;
    case 'organizations':
      return <OrganizationItem itemActionProps={itemActionProps} itemProps={itemProps} />;
    case 'programs':
      return <CurriculumItem itemActionProps={itemActionProps} itemProps={itemProps} />;
    case 'users':
      return <UserItem itemActionProps={itemActionProps} itemProps={itemProps} />;
  }
};
